import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fuji-billing-footer',
  templateUrl: './fuji-billing-footer.component.html',
  styleUrls: ['./fuji-billing-footer.component.css']
})
export class FujiBillingFooterComponent implements OnInit {
  currentYear = new Date().getFullYear();

  constructor() { }

  ngOnInit() {
  }

}
